import { Environments, getEnvironmentFromHost } from '../api/endpoints';

const MERCHANT_ID_PROD = 'merchant.com.aaa.ace.prod';
const MERCHANT_ID_NONPROD = 'merchant.com.aaa.ace.nonprod';

export function isMobileOrTablet(): boolean {
  return navigator.maxTouchPoints > 0 && /Mobi|iPad|iPhone|iPod|Android|Tablet/i.test(navigator.userAgent);
}

function getMerchantIdentifier(): string {
  return getEnvironmentFromHost(window.location.hostname) === Environments.prod
    ? MERCHANT_ID_PROD
    : MERCHANT_ID_NONPROD;
}

export function hasNativeApplePaySupport(): boolean {
  const ApplePaySession = (window as any).ApplePaySession;
  return (
    typeof ApplePaySession?.canMakePayments === 'function' &&
    typeof ApplePaySession?.supportsVersion === 'function'
  );
}

export async function isApplePayAvailable(enableApplePayQRCode?: boolean): Promise<boolean> {
  const ApplePaySession = (window as any).ApplePaySession;
  if (!ApplePaySession) return false;

  if (!hasNativeApplePaySupport()) {
    if (!enableApplePayQRCode) return false;

    if (typeof ApplePaySession.applePayCapabilities === 'function') {
      try {
        const { paymentCredentialStatus } = await ApplePaySession.applePayCapabilities(getMerchantIdentifier());
        return (
          paymentCredentialStatus === 'paymentCredentialsAvailable' ||
          paymentCredentialStatus === 'paymentCredentialStatusUnknown'
        );
      } catch {
        return false;
      }
    }
    return false;
  }

  try {
    return !!ApplePaySession.canMakePayments?.();
  } catch {
    return false;
  }
}
